import React, { useState } from 'react';
import axios from 'axios';
import { NavLink } from 'react-router-dom';
import '../HomePage.css'; // Import the CSS file
import './UserDashboard.css';
import LocalStorageUtil from './LocalStorageUtil';
import { WordTagControls } from './UserDashTagUtil';
import UserDashps from './UsrDashPsUtil';

const UserDashboard = () => {
const baseHostUrl = process.env.NODE_ENV === 'production' ? 'https://growlemma.com' : 'http://localhost:80';
const baseLocalDevUrl = process.env.NODE_ENV === 'production' ? 'https://growlemma.com' : 'http://localhost:3000';
const session = LocalStorageUtil.getSession();
const [showLemma, setShowLemma] = useState(session?.usrprofile?.showlemma === 1);
const [showPinyin,setShowPinyin] = useState(session?.usrprofile?.showpinyin === 1);
const [showtbselect,setShowTbselect] = useState(session?.usrprofile?.showtbselect === 1);
// alert(`usrprofile:\n${JSON.stringify(session.usrprofile, null, 2)}`);
// console.log('matched:', session.usrprofile.defaultlist);
const handleToggle = async () => {
    const newValue = showLemma ? 0 : 1;
    const newProfile = { ...session.usrprofile, showlemma: newValue };
    //this is for showlemma toggle
    await axios.post(`${baseHostUrl}/update-profile-lemma`, {
      username: session.username,
      usrprofile: newProfile
    }, {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true
    });

    const updatedSession = { ...session, usrprofile: newProfile };
    LocalStorageUtil.saveSession(updatedSession);
    setShowLemma(!showLemma);
  };

  const handleTogglePinyin = async () => {
    const newValue = showPinyin ? 0 : 1;
    const newProfile = { ...session.usrprofile, showpinyin: newValue };
    //this is for showlemma toggle
    await axios.post(`${baseHostUrl}/update-profile-lemma`, {
      username: session.username,
      usrprofile: newProfile
    }, {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true
    });

    const updatedSession = { ...session, usrprofile: newProfile };
    LocalStorageUtil.saveSession(updatedSession);
    setShowPinyin(!showPinyin);
  };
  const handleToggleTbselect = async () => {
    const newValue = showtbselect ? 0 : 1;
    const newProfile = { ...session.usrprofile, showtbselect: newValue };
    //this is for showlemma toggle
    await axios.post(`${baseHostUrl}/update-profile-lemma`, {
      username: session.username,
      usrprofile: newProfile
    }, {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true
    });

    const updatedSession = { ...session, usrprofile: newProfile };
    LocalStorageUtil.saveSession(updatedSession);
    setShowTbselect(!showtbselect);
  };
  return (
    <>
      <div className="hpTopBanner">
        <span className="hpLogo">Iezloc</span>
        <ul className="hpNavigationMenu">
          {/* <li>Home</li> */}
          <li><NavLink to="/" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Home</NavLink></li>
          <li><NavLink to="/lemma"  className={({ isActive }) => (isActive ? 'activeLink' : '')} >Lemma</NavLink></li>
          <li><NavLink to="/progress" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Progress</NavLink></li>
           <li><NavLink to="/cmnlemma"  className={({ isActive }) => (isActive ? 'activeLink' : '')} >Cmnlemma</NavLink></li>
           <li><NavLink to="/cmnprogress" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Cmnprogress</NavLink></li>
           <li><NavLink to="/cmnphrase" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Cmnphrase</NavLink></li>
          <li><NavLink to="/cmnbook" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Cmnbook</NavLink></li>
          <li><NavLink to="/dashboard" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Dashboard</NavLink></li>
          <li><NavLink to="/logout" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Logout</NavLink></li>
          {/* <li>Contact</li> */}
        </ul>
      </div>
      <div className="dashboard_wrapper">
      <div className="dashboard_container">
        <h2>Welcome, {session?.username} 👋</h2>
        <div className="db-toggle-wrapper">
        <span className="db-toggle-label">Enable Lemma</span>
        <label className="db-toggle-switch">
            <input type="checkbox" checked={showLemma} onChange={handleToggle} />
            <span className="db-slider"></span>
        </label>
        </div>
        <div className="db-toggle-wrapper">
        <span className="db-toggle-label">Enable pinyin</span>
        <label className="db-toggle-switch">
            <input type="checkbox" checked={showPinyin} onChange={handleTogglePinyin} />
            <span className="db-slider"></span>
        </label>
        </div>
        <div className="db-toggle-wrapper">
        <span className="db-toggle-label">Enable textbook selection</span>
        <label className="db-toggle-switch">
            <input type="checkbox" checked={showtbselect} onChange={handleToggleTbselect} />
            <span className="db-slider"></span>
        </label>
        </div>
        <WordTagControls baseHostUrl={baseHostUrl}/>
        <UserDashps session={session} baseHostUrl={baseHostUrl} />

      </div>
    </div>
    </>
  );
}
export default UserDashboard;